import React from 'react';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { TextField, FormControl, InputAdornment, IconButton } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { CalendarToday as CalendarIcon } from '@mui/icons-material';
import { Controller } from 'react-hook-form';
import dayjs from 'dayjs';
import FormErrorMessage from '../Errormessage';

const DateSelector = ({
    error,
    messages,
    control,
    label,
    name,
    placeholder = 'Select date',
    className,
    minDate,
    maxDate,
    dateFormat = 'YYYY-MM-DD',
    disabled,
    ...rest
}) => {
    const validateDateFormat = (date) => {
        if (!date) return true;
        return dayjs(date, dateFormat, true)?.isValid();
    };

    return (
        <FormControl className={className}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Controller
                    name={name}
                    control={control}
                    rules={{
                        required: messages?.required,
                        validate: {
                            validDateFormat: (value) => validateDateFormat(value) || `Date must be in ${dateFormat} format`,
                        },
                    }}
                    render={({ field: { onChange, onBlur, value, ref } }) => (
                        <DatePicker
                            disabled = {disabled}
                            label={label}
                            value={value ? dayjs(value, dateFormat) : null}
                            onChange={(date) =>
                                onChange(date ? dayjs(date).format(dateFormat) : null)
                            }
                            minDate={minDate ? dayjs(minDate, dateFormat) : undefined}
                            maxDate={maxDate ? dayjs(maxDate, dateFormat) : undefined}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder={placeholder}
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton>
                                                    <CalendarIcon />
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                    inputRef={ref}
                                    onBlur={onBlur}
                                />
                            )}
                            {...rest}
                        />
                    )}
                />
            </LocalizationProvider>
            <div>
                <FormErrorMessage error={error} messages={messages} />
            </div>
        </FormControl>
    );
};

export default DateSelector;